<template>
    <span v-if="field.IsExcused" class="material-icons-outlined text-info d-block">run_circle</span>
    <span v-else-if="field.IsEmployeeWorking && field.IsUploaded && !field.IsManuelRecord" class="material-icons-outlined text-success d-block">check_circle</span>
    <!-- <span v-on:click="$emit('action',row,field)" v-else-if="field.IsEmployeeWorking && field.IsManuelRecord && field.IsUploaded" class="material-icons-outlined text-warning c-pointer d-block" >error_outline</span>
    <span v-on:click="$emit('action',row,field)" v-else-if="field.IsEmployeeWorking" class="material-icons-outlined text-danger c-pointer d-block">cancel</span> -->
    <span v-else-if="field.IsEmployeeWorking && field.IsManuelRecord && field.IsUploaded" class="material-icons-outlined text-warning d-block" >error_outline</span>
    <span v-else-if="field.IsEmployeeWorking" class="material-icons-outlined text-danger d-block">cancel</span>
    <span v-else class="material-icons-outlined text-muted d-block">adjust</span>
</template>

<script>
export default {
    props:{
        row:Object,
        field:Object
    },
}
</script>

<style>
.c-not-wallowed{
    cursor: not-allowed;
}
</style>